import styles from "@/styles/checkout/common.module.scss"

interface Props {
  value: 0 | 1 | 2;
  onStepClick?: (step: number) => void;
}
export default function Steps({ value, onStepClick }: Props) {

  const handleClick = (step: number) => {
    if (onStepClick) {
      onStepClick(step);
    }
  };

  return (
    <div className={styles['steps']}>
      <div 
        onClick={() => handleClick(0)}
        className={`
          ${styles['steps-item']} 
          ${value == 0 ? styles['active'] : styles[`grayscale-${value}`]}`
        }
      >Shopping Cart</div>

      <div 
        onClick={() => handleClick(1)}
        className={`
          ${styles['steps-item']} 
          ${value == 1 ? styles['active'] : styles[`grayscale-${value}`]}`
        }
      >Shipping & Payment</div>

      <div 
        onClick={() => handleClick(2)}
        className={`
          ${styles['steps-item']} 
          ${value == 2 ? styles['active'] : styles[`grayscale-${value}`]}`
        }>Order complete</div>
    </div>
  )
}